export default __webpack_public_path__ + "static/media/09_crocodile.488d4195.webp";